(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inovago-contact"] && !Shopify.designMode) return;
  try {
    
function prefillInovagoService(root){const requested=new URLSearchParams(location.search).get('service');if(!requested)return;root.querySelectorAll('.inv-contact select[name="contact[Besoin]"]').forEach(select=>{if(!select.value&&Array.from(select.options).some(option=>option.value===requested))select.value=requested;});}
prefillInovagoService(document);
document.addEventListener('shopify:section:load',event=>prefillInovagoService(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inovago-header"]) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.inv-service-menu[open],.inv-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;});});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.inv-service-menu[open],.inv-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inovago-service-catalog"] && !Shopify.designMode) return;
  try {
    
function initInovagoCatalog(root) {
  root.querySelectorAll('[data-service-catalog]').forEach(catalog => {
    const tools = catalog.querySelector('[data-service-tools]');
    if (!tools || catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    tools.hidden = false;
    const search = catalog.querySelector('[data-service-search]');
    const group = catalog.querySelector('[data-service-group]');
    const cards = Array.from(catalog.querySelectorAll('[data-service-card]'));
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    function filter() {
      const query = normalize(search.value.trim());
      let count = 0;
      cards.forEach(card => {
        const visible = (group.value === 'all' || card.dataset.group === group.value || (group.value === 'training' && card.dataset.training === 'true')) && normalize(card.textContent).includes(query);
        card.hidden = !visible;
        if (visible) count++;
      });
      catalog.querySelector('[data-service-count]').textContent = count + ' ' + catalog.querySelector('[data-service-count-label]').textContent;
      catalog.querySelector('[data-service-none]').hidden = count !== 0;
    }
    const requestedGroup = new URLSearchParams(window.location.search).get('service');
    if (Array.from(group.options).some(option => option.value === requestedGroup)) group.value = requestedGroup;
    search.addEventListener('input', filter);
    group.addEventListener('change', () => { filter(); const url = new URL(window.location.href); if(group.value === 'all')url.searchParams.delete('service');else url.searchParams.set('service', group.value); history.replaceState(null, '', url); });
    filter();
  });
}
initInovagoCatalog(document);
document.addEventListener('shopify:section:load', event => initInovagoCatalog(event.target));

  } catch(e) { console.error(e); }
})();
})();
